export default __webpack_public_path__ + "static/media/default.5e3a03663de6bd4b914d3b88bc239863.svg";